import React, { useEffect, useState } from "react";
import { getTargetsForDeprecation } from "../../../utils/api";
import { getGlobalState } from "../../../utils/globalState";

const UnusedDashboards = ({
  expandedSections,
  toggleSection,
  runAs,
  theme,
}) => {
  const myUserId = getGlobalState().myUserId;
  const runner = runAs === "admin" ? 2 : myUserId;

  const [unusedDashboards, setUnusedDashboards] = useState([]);
  const [loadingUnused, setLoadingUnused] = useState(true);
  const [filters, setFilters] = useState({
    name: "",
    owner: "",
    instance: "",
    status: "",
    daysSinceViewed: "",
  });

  const applyFilters = (data) => {
    return data.filter((item) => {
      return (
        (filters.name === "" ||
          item.dashboard_name
            .toLowerCase()
            .includes(filters.name.toLowerCase())) &&
        (filters.owner === "" ||
          item.owner.toLowerCase().includes(filters.owner.toLowerCase())) &&
        (filters.instance === "" || item.instance_name === filters.instance) &&
        (filters.status === "" || item.status === filters.status) &&
        (filters.daysSinceViewed === "" ||
          item.days_since_viewed >= parseInt(filters.daysSinceViewed))
      );
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingUnused(true);
        const unusedDashboardsData = await getTargetsForDeprecation(runner);
        setUnusedDashboards(unusedDashboardsData);
        setLoadingUnused(false);
      } catch (error) {
        setLoadingUnused(false);
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [myUserId]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const filteredUnusedDashboards = applyFilters(unusedDashboards);
  const itemsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(1);
  const currentItems = filteredUnusedDashboards.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const uniqueInstances = [
    ...new Set(unusedDashboards.map((dashboard) => dashboard.instance_name)),
  ];
  const uniqueStatuses = [
    ...new Set(unusedDashboards.map((dashboard) => dashboard.status)),
  ];

  const renderPagination = () => {
    const totalPages = Math.ceil(
      filteredUnusedDashboards.length / itemsPerPage
    );
    const paginationLinks = [];

    if (totalPages <= 4) {
      // Show all pages if total pages are 4 or less
      for (let i = 1; i <= totalPages; i++) {
        paginationLinks.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            className={`relative inline-flex items-center px-4 py-2 text-sm font-medium ${
              currentPage === i
                ? "z-10 focus:z-20"
                : " text-gray-500 hover:bg-gray-50 focus:z-20"
            } border border-gray-300 mx-1 rounded`}
             style={currentPage === i ? { backgroundColor: theme.leftNavBackgroundColor, color: "#fff" } : {backgroundColor: "#fff"}}
          >
            {i}
          </button>
        );
      }
    } else {
      // Always show first, second, penultimate, and last pages
      paginationLinks.push(
        <button
          key={1}
          onClick={() => handlePageChange(1)}
        //   className={currentPage === 1 ? "active" : ""}
        className={`relative inline-flex items-center px-4 py-2 text-sm font-medium ${
          currentPage === 1
            ? 'z-10 bg-blue-600 text-white focus:z-20'
            : 'bg-white text-gray-500 hover:bg-gray-50 focus:z-20'
        } border border-gray-300 mx-1 rounded`}
          style={currentPage === 1 ? { backgroundColor: theme.leftNavBackgroundColor, color: "#fff" } : {backgroundColor: "#fff"}}
        >
          1
        </button>
      );

      paginationLinks.push(
        <button
          key={2}
          onClick={() => handlePageChange(2)}
        //   className={currentPage === 2 ? "active" : ""}
        className={`relative inline-flex items-center px-4 py-2 text-sm font-medium ${
          currentPage === 2
            ? 'z-10 bg-blue-600 text-white focus:z-20'
            : 'bg-white text-gray-500 hover:bg-gray-50 focus:z-20'
        } border border-gray-300 mx-1 rounded`}
          style={currentPage === 2 ? { backgroundColor: theme.leftNavBackgroundColor, color: "#fff" } : {backgroundColor: "#fff"}}
        >
          2
        </button>
      );

      if (currentPage > 3) {
        paginationLinks.push(<span key="ellipsis1" className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 mx-1 rounded">...</span>);
      }

      if (currentPage > 2 && currentPage < totalPages - 1) {
        paginationLinks.push(
          <button
            key={currentPage}
            onClick={() => handlePageChange(currentPage)}
            className="relative inline-flex items-center px-4 py-2 text-sm font-medium z-10 bg-blue-600 text-white focus:z-20 border border-gray-300 mx-1 rounded"
          >
            {currentPage}
          </button>
        );
      }

      if (currentPage < totalPages - 2) {
        paginationLinks.push(<span key="ellipsis2" className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 mx-1 rounded">...</span>);
      }

      paginationLinks.push(
        <button
          key={totalPages - 1}
          onClick={() => handlePageChange(totalPages - 1)}
           className={`relative inline-flex items-center px-4 py-2 text-sm font-medium ${
          currentPage === totalPages - 1
            ? 'z-10  focus:z-20'
            : 'bg-white text-gray-500 hover:bg-gray-50 focus:z-20'
        } border border-gray-300 mx-1 rounded`}
          style={currentPage === totalPages - 1 ? { backgroundColor: theme.leftNavBackgroundColor, color: "#fff" } : {backgroundColor: "#fff"}}
        >
          {totalPages - 1}
        </button>
      );

      paginationLinks.push(
        <button
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
          className={`relative inline-flex items-center px-4 py-2 text-sm font-medium ${
          currentPage === totalPages
            ? 'z-10 text-white focus:z-20'
            : 'bg-white text-gray-500 hover:bg-gray-50 focus:z-20'
        } border border-gray-300 mx-1 rounded`}
          style={currentPage === totalPages ? { backgroundColor: theme.leftNavBackgroundColor, color: "#fff" } : {backgroundColor: "#fff"}}
        >
          {totalPages}
        </button>
      );
    }

    return (
      <div className="pagination">
        {currentPage > 1 && (
          <>
            <button className="relative inline-flex items-center px-4 py-2 mx-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50" onClick={() => handlePageChange(1)}>&lt;&lt;</button>
            <button className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50" onClick={() => handlePageChange(currentPage - 1)}>&lt;</button>
          </>
        )}
        {paginationLinks}
        {currentPage < totalPages && (
          <>
            <button className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50" onClick={() => handlePageChange(currentPage + 1)}>&gt;</button>
            <button className="relative inline-flex items-center mx-1 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50" onClick={() => handlePageChange(totalPages)}>&gt;&gt;</button>
          </>
        )}
      </div>
    );
  };

  return (
    <div className="section">
      {/* commented cause I use new tabs view instead expand view */}

      {/* <div className="section-header" onClick={() => toggleSection('unused')}>
                <h3>Unused Dashboards</h3>
                <i className={`fas fa-chevron-${expandedSections.unused ? 'up' : 'down'}`}></i>
            </div> */}
      {expandedSections.unused && (
        <div className="">
          {loadingUnused ? (
            <div>Loading...</div>
          ) : (
            <>
              {/* <p>Number of unused dashboards: {filteredUnusedDashboards.length}</p> */}
              <div className="mb-6">
                <h3 className="text-lg font-medium leading-6 text-gray-900">
                  Unused Dashboards
                </h3>
                <p
                  className="mt-2 text-sm text-gray-600 bg-blue-50 p-3 rounded-md border-l-4 border-blue-400"
                  style={{
                    borderLeftColor: theme.leftNavBackgroundColor,
                    backgroundColor: theme.lightColor,
                  }}
                >
                  Found {filteredUnusedDashboards.length} unused dashboards that
                  may be candidates for cleanup or archiving.
                </p>
              </div>
              <div className="overflow-x-auto rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="font-bold px-6 py-3 text-left text-sm text-gray-500 tracking-wider"
                      >
                        Dashboard Name
                      </th>
                      <th
                        scope="col"
                        className="font-bold px-6 py-3 text-left text-sm text-gray-500 tracking-wider"
                      >
                        Owner
                      </th>
                      <th
                        scope="col"
                        className="font-bold px-6 py-3 text-left text-sm text-gray-500 tracking-wider"
                      >
                        Instance
                      </th>
                      <th
                        scope="col"
                        className="font-bold px-6 py-3 text-left text-sm text-gray-500 tracking-wider"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className="font-bold px-6 py-3 text-left text-sm text-gray-500 tracking-wider"
                      >
                        Days Since Viewed
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    <tr>
                      <td className="px-6 py-2">
                        <input
                          type="text"
                          name="name"
                          placeholder="Filter by Name"
                          value={filters.name}
                          onChange={handleFilterChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                      </td>
                      <td className="px-6 py-2">
                        <input
                          type="text"
                          name="owner"
                          placeholder="Filter by Owner"
                          value={filters.owner}
                          onChange={handleFilterChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                      </td>
                      <td className="px-6 py-2">
                        <select
                          name="instance"
                          value={filters.instance}
                          onChange={handleFilterChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        >
                          <option value="">All Instances</option>
                          {uniqueInstances.map((instance, index) => (
                            <option key={index} value={instance}>
                              {instance}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td className="px-6 py-2">
                        <select
                          name="status"
                          value={filters.status}
                          onChange={handleFilterChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        >
                          <option value="">All Statuses</option>
                          {uniqueStatuses.map((status, index) => (
                            <option key={index} value={status}>
                              {status}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td className="px-6 py-2">
                        <input
                          type="number"
                          name="daysSinceViewed"
                          placeholder="Filter by Days Since Viewed"
                          value={filters.daysSinceViewed}
                          onChange={handleFilterChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                      </td>
                    </tr>
                    {currentItems.map((dashboard, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                      >
                        <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                          {dashboard.dashboard_name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-gray-500">
                          {dashboard.owner}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-gray-500">
                          {dashboard.instance_name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span
                            className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                              dashboard.status === "Published"
                                ? "bg-green-100 text-green-800"
                                : dashboard.status === "Pending"
                                ? "bg-yellow-100 text-yellow-800"
                                : "bg-gray-100 text-gray-800"
                            }`}
                          >
                            {dashboard.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-gray-500">
                          {dashboard.days_since_viewed}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="pagination">{renderPagination()}</div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default UnusedDashboards;
